import { Link } from 'react-router-dom';
import './screens.css';

export default function NotFoundScreen() {
  return (
    <div className="screen">
      <div>
        <p className="screen__eyebrow">404</p>
        <h1 className="screen__title">That route doesn't exist.</h1>
        <p className="screen__sub">
          <Link to="/">Back to dashboard</Link>
        </p>
      </div>
    </div>
  );
}
